import { EarthBrainViewerAPIs } from "./EarthBrainViewerAPIs";
export class MeasurementAPIs extends EarthBrainViewerAPIs {
    enableMeasurementCreation() {
        return this._scDesign.enableMeasurementCreation();
    }
    cancelMeasurement() {
        this._scDesign.cancelMeasurement();
    }
    async loadMeasurement(id, type, data) {
        await this._scDesign.loadMeasurement(id, type, data);
        return;
    }
    async showMeasurement(id, type) {
        await this._scDesign.showMeasurement(id, type);
        return;
    }
    async updateMeasurement(id, type) {
        await this._scDesign.updateMeasurement(id, type);
        return;
    }
    hideMeasurement(id, type) {
        this._scDesign.hideMeasurement(id, type);
    }
    editMeasurement() {
        return new Promise((resolve) => {
            resolve([]);
        });
    }
    deleteMeasurement(id) {
        this._scDesign.deleteMeasurement(id);
    }
    zoomToMeasurement(id, type) {
        return this._scDesign.zoomToMeasurement(id, type);
    }
}
//# sourceMappingURL=measurement.js.map